import config from '../config/config.js'; // intentionally absolute import so we can use it without before aliases are loaded.

export function isExternal(url) {
    return /^https?:\/\//i.test(url);
}

export function makeRelative(url) {
    return url?.replace(config.self.url, '') ?? '';
}
